import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/**
 * Records that an operator with PIN authority bypassed the parcel-photo
 * minimum-count requirement for this fulfillment group. Fires a
 * `PARCEL_PHOTO_REQUIREMENT_BYPASSED` timeline event so the bypass is
 * auditable from the FG slideout / detail / order timeline.
 *
 * `capturedCount` / `minCount` are snapshotted at bypass time so the
 * event preserves "how short the operator was" even if photos are
 * subsequently added or deleted.
 */
export const recordParcelPhotoBypass = {
  name: "recordParcelPhotoBypass" as const,
  input: z.object({
    fulfillmentGroupId: zExt.objectId(),
    capturedCount: z.number().int().nonnegative(),
    minCount: z.number().int().nonnegative(),
  }),
  output: z.object({ success: z.boolean() }),
};
